<template>
  <div class="BoxContent">
    <div class="boxOne">
      <div class="leftLogo skeleton"></div>
      <div class="rightBox">
        <span class="font1 skeleton"></span>
        <div class="topBox">
          <span class="font2 skeleton"></span>
          <span class="font3 skeleton"></span>
        </div>
      </div>
    </div>
    <div class="boxThree">
      <div class="topBox">
        <div class="topImg skeleton"></div>
        <span class="font4 skeleton"></span>
      </div>
      <div class="cBoxNo"></div>
      <div class="btn skeleton"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.BoxContent {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 64px);
  .boxOne {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 32px;
    // margin-top: 32px;
    width: 576px;
    height: 124px;
    min-height: 124px;
    max-height: 124px;
    margin-bottom: 20px;
    .leftLogo {
      width: 44px;
      height: 44px;
      border-radius: 50%;
    }
    .rightBox {
      display: flex;
      flex-direction: column;
      margin-left: 12px;
      .font1 {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 22px;
        width: 436px;
        height: 22px;
        border-radius: 8px;
        margin-bottom: 2px;
        @include multiline(2);
      }
      .topBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .font2 {
          font-weight: 400;
          font-size: 12px;
          color: #8a8b92;
          line-height: 20px;
          height: 20px;
          border-radius: 8px;
          flex: 1;
          max-width: 404px;
          @include multiline(1);
        }
        .font3 {
          font-weight: 400;
          font-size: 12px;
          color: #f67942;
          line-height: 20px;
          height: 20px;
          width: 24px;
          border-radius: 8px;
          text-decoration: underline;
          text-decoration-color: #f67942;
          margin-left: 20px;
          cursor: pointer;
        }
      }
    }
  }
  .boxThree {
    width: 576px;
    height: 276px;
    min-height: 276px;
    max-height: 276px;
    background: #ffffff;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 36px;
    .topBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 32px;
      .topImg {
        width: 44px;
        height: 44px;
      }
      .font4 {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 22px;
        margin-left: 12px;
        max-width: 448px;
        height: 22px;
        flex: 1;
        border-radius: 8px;
        @include multiline(2);
      }
    }
    .cBoxNo {
      width: 100%;
      height: 44px;
      background: #f6f6f6;
      border-radius: 8px;
      margin-bottom: 28px;
    }
    .btn {
      width: 140px;
      height: 48px;
      border-radius: 26px;
    }
  }
}
</style>
